import React from 'react'

import { useQuery } from '@apollo/client'
import { cloneDeep } from 'lodash/lang'

import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      camperId, // via withParams
      setCamperForm, // via redux actions
      setErrorMessage, // via redux actions
      setFormErrors, // via withFormErrors -> withState
      setCamperFormField, // via redux actions
      onQueryError, // via withQueryResults
      onLoggedInQueryCompleted // via withQueryResults
    } = props

    // react hooks
    const {
      loading: queryLoading,
      error: queryError,
      data: queryData
    } = useQuery(query, {
      variables: { camperId },
      onError: onQueryError,
      onCompleted: data => handleQueryCompleted(data)
    })

    const handleQueryCompleted = data => {
      if (!onLoggedInQueryCompleted(data)) {
        return
      }

      if (data && data.viewer) {
        const camper = data.viewer.campers[0]

        if (!camper) {
          setErrorMessage('The camper was not found')
          return
        }

        setCamperForm(cloneDeep(camper))

        if (!camper.confirmed) {
          setErrorMessage(
            'Please verify the information below and click "Confirm"'
          )
          setFormErrors({
            ...(!camper.school && { school: ' ' }),
            ...(!camper.immunizations && { immunizations: ' ' }),
            ...(!camper.doctorName && { doctorName: ' ' }),
            ...(!camper.doctorPhoneNumber && { doctorPhoneNumber: ' ' })
          })
        }

        // remove legacy dietary restrictions from selection
        const restrictions = camper.dietaryRestrictions.filter(
          name => dietaryRestrictions.map(r => r.name).indexOf(name) >= 0
        )
        setCamperFormField('dietaryRestrictions', restrictions)
      }
    }

    // GraphQL data
    const {
      viewer: account,
      seasons,
      allergies,
      dietaryRestrictions
    } = queryData || {}
    const camper = account ? account.campers[0] : null
    const season = seasons ? seasons[0] : null

    return (
      <WrappedComponent
        queryLoading={queryLoading}
        queryError={queryError}
        account={account}
        camper={camper}
        allergies={allergies || []}
        dietaryRestrictions={dietaryRestrictions || []}
        season={season}
        {...props}
      />
    )
  }
}

export default withQuery
